import EscalatedCaseTag from './EscalatedCaseTag'

export default EscalatedCaseTag
